<template>
    <!--
        Solo aparece cuando la conexion del puesto esta mal. Si el lento es el
        servidor no se muestra nada: eso queda en los logs. El usuario final no
        es tecnico y un mensaje tecnico solo genera otra llamada.
    -->
    <div v-if="inestable" class="d-flex align-items-center text-warning mr-3" :title="titulo">
        <i class="fas fa-wifi fa-fw"></i>
        <span class="small font-weight-bold ml-1 d-none d-md-inline">Conexión inestable</span>
    </div>
</template>

<script>
import { estado } from "../../monitoring/calidadConexion";

export default {
    name: "IndicadorConexion",

    computed: {
        inestable() {
            return estado.inestable;
        },
    },

    data() {
        return {
            // Sin cifras ni diagnostico: el detalle vive en los logs.
            titulo: "La conexión a internet de este equipo está presentando intermitencias",
        };
    },
};
</script>
